import { configQuery } from '@gig/magic-common';
import { CLOUDFLARE_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';

var CloudflareService = /** @class */ (function () {
    function CloudflareService() {
        this.response = '';
        this.registerQuery();
    }
    CloudflareService.prototype.registerQuery = function () {
        var _this = this;
        window.queryBus.subscribe(CLOUDFLARE_QUERY, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, property;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.response) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.getResponse()];
                    case 1:
                        _a.response = _b.sent();
                        _b.label = 2;
                    case 2:
                        property = event.payload;
                        if (!property) {
                            return [2 /*return*/, this.response];
                        }
                        return [2 /*return*/, this.getResponseProperty(property)];
                }
            });
        }); });
    };
    CloudflareService.prototype.getResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var domain, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, configQuery('cloudflareDomain')];
                    case 1:
                        domain = _a.sent();
                        return [4 /*yield*/, fetch(domain + "/cdn-cgi/trace")];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.text()];
                }
            });
        });
    };
    CloudflareService.prototype.getResponseProperty = function (property) {
        var part = this.response
            .split('\n')
            .find(function (part) { return part.trim().startsWith(property + "="); });
        return (part === null || part === void 0 ? void 0 : part.split('=')[1]) || '';
    };
    return CloudflareService;
}());

export { CloudflareService };
